import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import{ HistoryLayout } from "../../../../../common/history/history-layout.component";
import { TablePagination } from '../../../../../common/details-table/table-pagination.component';
import { articleHistoryActions } from "../../../../../../store/external/recharge-reducer/history/article-history-reducer";
import { MODAL_CUSTOM_MESSAGE } from "../../../../../../constants/external-constants";

class ArticleHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            enableSearchBox: false,
            exportAlertMsg: MODAL_CUSTOM_MESSAGE.export_alert_message,
        }

    }

    componentWillUnmount() {
        this.props.resetArticleHistory()
    }

    componentDidMount() {
        this.props.getArticleHistoryLogs(this.props.articleId)
    }

    onColumnSearch = () => {
        const { getArticleHistoryLogs, articleId } = this.props;
        getArticleHistoryLogs(articleId, 0)
    }

    articlePaginationAction = (pageIndex) => {
        const { getArticleHistoryLogs, articleId } = this.props;
        getArticleHistoryLogs(articleId, pageIndex);
    }

    resizePage = (pageSize) => {
        const { resizeArticleHistoryLogs, getArticleHistoryLogs, articleId } = this.props;
        resizeArticleHistoryLogs(pageSize)
        getArticleHistoryLogs(articleId);
    }

    displaySearchBox = (value) => {
        this.setState({ enableSearchBox: value })
    }

    onClickExtract = () => {
        const { articleId, extractArticleHistoryLogs } = this.props;
        if (window.confirm(this.state.exportAlertMsg)) {
            extractArticleHistoryLogs(articleId);
        }
    }  

    render() {
        const { setArticleHistoryColSearchStr, isColSearchShow } = this.props;
        const { IsLoadingTable } = this.props.articleHistory;
        const { Headers, Data, Pagination } = this.props.articleHistory.HistoryTable;
        const { isReadOnly, isReadAndExtractOnly, isReadAndWrite } = this.props;
        return (
            <div>
            <HistoryLayout
             displaySearchBox={this.displaySearchBox}
             extractAction={this.onClickExtract}
             isViewing={this.props.isViewing}

            //Access Type
            isReadOnly={isReadOnly}
            isReadAndExtractOnly={isReadAndExtractOnly}
            isReadAndWrite={isReadAndWrite} 
            hideCustomColumn={true}
            >
                <TablePagination
                    key="table-pagination-key"
                    columns={Headers}
                    pageList={Data}                 
                    pages={Pagination}
                    paginationAction={this.articlePaginationAction}
                    onColumnSearch={this.onColumnSearch}
                    onColumnSearchChange={setArticleHistoryColSearchStr}
                    isColSearchShow={this.state.enableSearchBox}
                    resizePage={this.resizePage}
                    totalPage={Pagination.TotalEntries}
                    isLoading={IsLoadingTable}
                    hideStatusIcon={true}   
                    isNotSortable={true}
                />
            </HistoryLayout>
        </div>
        );
    }
}

export default connect(
    state => {
        const { articleHistory } = state;
        return {
            articleHistory
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, articleHistoryActions),
        dispatch
    )
)(ArticleHistory);